import { FC } from 'react'
import { CopyOutlined } from '@ant-design/icons'
import cn from './index.module.css'
import { useAddAlert } from '@/hooks/useAddAlert'

interface ILinkView {
  link: string
  onClick?: (e: React.MouseEvent) => void
}

const LinkView: FC<ILinkView> = ({ link, onClick }) => {
  const addAlert = useAddAlert()

  const onClickDefault = () => {
    addAlert({ title: 'Ссылка скопирована' })
    navigator.clipboard.writeText(link)
  }

  return (
    <div className={cn.linkWrapper} onClick={onClick ?? onClickDefault}>
      <div className={cn.link}>
        <span className={cn.linkText}>{link}</span>
      </div>
      <CopyOutlined
        className={cn.copyIcon}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
      />
    </div>
  )
}

export default LinkView
